import { distinctUntilChanged, map } from 'rxjs/operators';
import { gridEditor$ } from 'gridEditor/gridEditor$';
import { gridEditorStateOperations as gridEditorStateOperations } from 'gridEditor/gridEditorStateOperations';
import { isEqual } from 'lodash';

export const gridEditorOpenState$ = gridEditor$.pipe(
  map(gridEditor => {
    return {
      isGridEditorOpen:
        gridEditorStateOperations.isDockedGridEditorState(gridEditor) &&
        gridEditorStateOperations.isDockedGridEditorOpen(gridEditor),
      isGridEditorPoppedOut:
        gridEditorStateOperations.isPopoutGridEditorState(gridEditor) &&
        gridEditorStateOperations.isPopoutGridEditorOpen(gridEditor),
    };
  }),
  distinctUntilChanged(isEqual)
);
